<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Apply Work From Home</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Work from home created successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="wfhForm" #myForm="ngForm" (ngSubmit)="wfhFormSubmit()">
    
            <div class="side-by-side-mat-form-field">
                <mat-form-field>
                    <mat-label>Wfh From</mat-label>
                    <input matInput formControlName="leave_from" [max]="fromMaxDate" [min]="fromMinDate" (dateInput)="onFromDateChange($event)" [matDatepicker]="leave_from_date" (focus)="leave_from_date.open()">
                    <mat-datepicker-toggle matSuffix [for]="leave_from_date"></mat-datepicker-toggle>
                    <mat-datepicker #leave_from_date></mat-datepicker>
                    <mat-error *ngIf="wfhFormValidate?.leave_from?.errors?.required">This field is required.</mat-error>
    
                </mat-form-field>
    
                <mat-form-field>
                    <mat-label>Wfh To</mat-label>
                    <input matInput formControlName="leave_to" [max]="toMaxDate" [min]="toMinDate" (dateInput)="onToDateChange($event)" [matDatepicker]="leave_to_date" (focus)="leave_to_date.open()">
                    <mat-datepicker-toggle matSuffix [for]="leave_to_date"></mat-datepicker-toggle>
                    <mat-datepicker #leave_to_date></mat-datepicker>
                    <mat-error *ngIf="wfhFormValidate?.leave_to?.errors?.required">This field is required.</mat-error>
    
                </mat-form-field>
            </div>
            <div class="side-by-side-mat-form-field">
                <mat-form-field>
                    <mat-label> Days</mat-label>
                    <input type="text" formControlName="leave_days" matInput>
                    <mat-error *ngIf="wfhFormValidate?.leave_days?.errors?.required">This field is required.</mat-error>
                </mat-form-field>
            </div>
            <div class="side-by-side-mat-form-field">
                <!-- <mat-form-field *ngIf="isShowUsers">
                    <mat-label>User</mat-label>
                    <mat-select formControlName="user_id" (selectionChange)="  ($event?.value)">
                        <mat-option *ngFor="let user of users;" [value]="user?.id">
                            <span>{{user?.name}}</span>
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="leaveFormValidate?.user_id?.errors?.required">This field is required.</mat-error>
                </mat-form-field> -->
    
                <!-- <mat-form-field *ngIf="isShowUsers">
                    <mat-label>User</mat-label>
                    <input type="hidden" formControlName="user_id">
                    <input matInput placeholder="Search" [matAutocomplete]="auto" [formControl]="searchUserNameCtrl" [multiple]="true">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchUserName">
                        <mat-option *ngFor="let user of users;" [value]="user">
                            <span>{{user?.name}}</span>
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="wfhFormValidate?.user_id?.errors?.required">This field is required.</mat-error>
                </mat-form-field> -->
    
                <mat-form-field>
                    <mat-label>Apply To</mat-label>
                    <mat-select formControlName="applied_to">
                        <mat-option *ngFor="let applied_to_user of usersReport;" [value]="applied_to_user?.user_id">
                            <span>{{applied_to_user?.name}}</span>
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="wfhFormValidate?.applied_to?.errors?.required">This field is required.</mat-error>
                </mat-form-field>
            </div>
    
    
            <mat-form-field>
                <mat-label>Reason</mat-label>
                <textarea matInput formControlName="wfh_reason"></textarea>
            </mat-form-field>
    
    
            <div class="footer-block text-center">
                <div class="button-group">
                    <button type="submit" mat-raised-button class="btn-int-blue">Create </button>
                </div>
            </div>
        </form>
</div>